import CustomPopover from '../../Common/CustomPopover';
import AvatarButton from '../AvatarButton';
import FlyoutMenuContent from './FlyoutMenuContent';

export default function FlyoutMenu({ userDetails = {} }) {
  return (
    <CustomPopover
      triggerComponent={
        <AvatarButton
          height='h-[40px]'
          width='w-[40px]'
          userName={userDetails?.name}
          imagePath={userDetails?.profile_img?.path}
        />
      }
    >
      <FlyoutMenuContent userDetails={userDetails} />
    </CustomPopover>
  );
}
